import React, { Component } from 'react'
import { translate } from 'react-polyglot'
import PropTypes from 'prop-types'

import { ButtonGroup, Button, Modal, Text } from 'components'

// https://itnext.io/add-confirmation-dialog-to-react-events-f50a40d9a30d
class Confirm extends Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
			callback: null,
		}

		this.modal = React.createRef()
	}

	componentDidUpdate = () => {
		document.addEventListener('mousedown', this.handleClickOutside)
	}

	componentWillUnmount = () => {
		document.removeEventListener('mousedown', this.handleClickOutside)
	}

	handleClickOutside = event => {
		const container = this.modal.current

		if (container && !container.contains(event.target)) {
			this.close()
		}
	}

	open = callback => e => {
		const { onOpen } = this.props

		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}

		if (onOpen) onOpen()

		this.setState({
			open: true,
			callback: () => callback(),
		})
	}

	close = e => {
		const { onClose } = this.props

		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}

		if (onClose) onClose()

		this.setState({
			open: false,
			callback: null,
		})
	}

	confirm = e => {
		const { callback } = this.state

		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}

		callback()
		this.close()
	}

	render() {
		const {
			title,
			text,
			buttonText,
			buttonLayout,
			children,
			t,
		} = this.props

		const { open } = this.state

		return (
			<>
				{children(this.open)}

				{open && (
					<Modal
						visible={open}
						title={title || t('please_confirm')}
						onClose={this.close}
					>
						{text && <Text size="small">{text}</Text>}

						<ButtonGroup orientation="horizontal">
							<Button
								onClick={this.confirm}
								text={buttonText || t('confirm')}
								size="small"
								layout={buttonLayout}
							/>

							<Button onClick={this.close} text={t('cancel')} />
						</ButtonGroup>
					</Modal>
				)}
			</>
		)
	}
}

Confirm.propTypes = {
	title: PropTypes.string,
	text: PropTypes.node,
	buttonText: PropTypes.string,
	buttonLayout: PropTypes.string,
	children: PropTypes.func.isRequired,
}

Confirm.defaultProps = {
	title: null,
	text: null,
	buttonText: null,
	buttonLayout: 'warning',
}

export default translate()(Confirm)
